"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./WirelessCart.scss");
var ui_components_1 = require("@idp/ui-components");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var utils_1 = require("@idp/ui-components/utils");
var Utils = require("../../../utils/UtilityFunctions");
var cartUtils = require("../../../utils/CartUtilFunctions");
var RemoveModalContent_1 = require("../shared/RemoveModalContent");
var ReportingService_1 = require("../../../api/ReportingService");
var WirelessCartHelper_1 = require("./WirelessCartHelper");
var icons = require("../../../styles/ccc-icons-cart.scss");
var CartConfiguration_scss_1 = require("../../CartConfigurationContainer/CartConfiguration.scss");
var DueAmount_1 = require("../ExpressView/DueAmount/DueAmount");
var LabelProps_1 = require("@idp/ui-components/components/atoms/Label/LabelProps");
var wlsUtils = require("../../../utils/WirelessUtilFunctions");
var TextTooltip_1 = require("../shared/TextTooltip");
var WirelessSavings_1 = require("./WirelessSavings");
var components_1 = require("@idp/duc/components");
var Button_1 = require("@idp/ui-components/components/atoms/Button/");
var wirelessRTI = require("./WirelessRTI");
var WirelessCRP_1 = require("./WirelessCRP");
var ButtonProps_1 = require("@idp/ui-components/components/atoms/Button/ButtonProps");
var CartUtilFunctions_1 = require("../../../utils/CartUtilFunctions");
var RetailerOffer_1 = require("../../panels/RetailerOffer/RetailerOffer");
var UnauthAccess_1 = require("../../CommonCart/common/UnauthAccess/UnauthAccess");
var ExpressCart = /** @class */ (function (_super) {
    __extends(ExpressCart, _super);
    function ExpressCart(props) {
        var _this = _super.call(this, props) || this;
        _this.expUpLineCount = 0;
        _this.isCrpUpgrade = false;
        _this.isCRPStandAloneMessage = true;
        _this.state = {
            accessFeeHelpModalDisplay: false,
            bogoSeeOfferModalDisplayed: false,
            isModalOpen: false,
            isRemoveModalOpen: false,
            legalContenFound: false,
            productDetails: {},
            showMonthlySavings: false,
        };
        _this.wirelessSavings = new WirelessSavings_1.default();
        _this.initializeEvents();
        _this.bindThisToFunctions();
        _this.displayLineItems = _this.displayLineItems.bind(_this);
        _this.displayPlanDetails = _this.displayPlanDetails.bind(_this);
        _this.getActivationLineItemContent = _this.getActivationLineItemContent.bind(_this);
        _this.expressUpView = _this.expressUpView.bind(_this);
        _this.setDeliveryDates = _this.setDeliveryDates.bind(_this);
        _this.expUpFilterLineItems = _this.expUpFilterLineItems.bind(_this);
        _this.expUpDisplayLineItems = _this.expUpDisplayLineItems.bind(_this);
        _this.expUpEarlyUpgrade = _this.expUpEarlyUpgrade.bind(_this);
        _this.showPromotions = _this.showPromotions.bind(_this);
        _this.showInstallmentMessage = _this.showInstallmentMessage.bind(_this);
        _this.showExpUpLegal = _this.showExpUpLegal.bind(_this);
        _this.expupDueTodaySection = _this.expupDueTodaySection.bind(_this);
        _this.expupDueMonthlySection = _this.expupDueMonthlySection.bind(_this);
        _this.expupDueOnFirstBillSection = _this.expupDueOnFirstBillSection.bind(_this);
        _this.getLosgLineItem = _this.getLosgLineItem.bind(_this);
        _this.getPlanDetails = _this.getPlanDetails.bind(_this);
        _this.showNewSavingAndPromo = _this.showNewSavingAndPromo.bind(_this);
        _this.showUpgradeLink = _this.showUpgradeLink.bind(_this);
        _this.expressFlowLineNames = _this.expressFlowLineNames.bind(_this);
        _this.expupOther = _this.expupOther.bind(_this);
        _this.renderUpgradeCta = _this.renderUpgradeCta.bind(_this);
        _this.upgradeCtaEvent = _this.upgradeCtaEvent.bind(_this);
        return _this;
    }
    ExpressCart.prototype.componentWillMount = function () {
        var payload = cartUtils.getWirelessCart();
        if (payload && payload.wirelessCart) {
            this.cartData = payload && payload.wirelessCart;
            this.orderSubType = payload.metadata && payload.metadata.metadata && payload.metadata.metadata.orderSubType;
            this.cartMetaData = payload.metadata && payload.metadata.metadata && payload.metadata.metadata.wirelessMetadata;
            this.wlsEarlyUpgradePriceFeature = payload.wirelessEarlyUpgradePriceFeature;
            this.b2bDetail = payload.b2bDetail || {};
            this.shippingDetails = payload.shippingDetails;
            this.savingsPromoFlags = cartUtils.getSavingsPromoFlags();
        }
        this.isAALFlow = Utils.isAALFlow();
        this.isMixAndMatch = this.cartData && this.cartData.mixAndMatch;
        this.eapFlowContext = cartUtils.getEAPDetails();
        this.payload = payload;
        if (this.eapFlowContext &&
            this.eapFlowContext.isEAPFlow &&
            (this.eapFlowContext.eapFlowType === 'NEW_EAP_ON' || this.eapFlowContext.eapFlowType === 'AAL_EAP_ON')) {
            this.hideEditAndRemoveLink = true;
        }
        if (this.isExpressUp()) {
            this.expUpdueTodayLegal = Utils.getLegalData(Utils.getLegalInfo(this.cartSummaryCMSData, this.externalOrderSourceType).dueTodayLegal);
            this.expUpdue1stBillLegal = Utils.getLegalData(Utils.getLegalInfo(this.cartSummaryCMSData, this.externalOrderSourceType).dueFirstMonthLegal);
        }
    };
    ExpressCart.prototype.componentDidMount = function () {
        var _this = this;
        if (!Utils.isEnableValidateInventory()) {
            this.getEstDeliveryDates();
        }
        this.savingsPromoFlags = cartUtils.getSavingsPromoFlags();
        cartUtils.globalNavForSMBCustomer();
        var attAdminFeeLegal = Utils.getLegalInfo(this.cartSummaryCMSData, this.externalOrderSourceType);
        if (this.payload && this.payload.addOnDueAmount && this.payload.addOnDueAmount !== 0 &&
            attAdminFeeLegal && attAdminFeeLegal.govTaxLegal) {
            var legalObj = attAdminFeeLegal.govTaxLegal;
            var legalContent_1 = {};
            cartUtils
                .getLegalIDPData(legalObj.legalModalPath, legalContent_1, legalObj.legallinkText, legalObj.shortText)
                .then(function (legaldataobj) {
                legalContent_1 = legaldataobj;
                _this.govTaxandFeeLegal = legalContent_1;
                _this.setState({ legalContenFound: _this.state.legalContenFound });
            });
        }
    };
    ExpressCart.prototype.showNewSavingAndPromo = function () {
        if (this.externalOrderSourceType) {
            return React.createElement(React.Fragment, null, " ");
        }
        return this.wirelessSavings.getSavingsAndPromos({
            eapFlowContext: this.eapFlowContext,
            isExpressFlow: this.isExpressUp(),
            isMixAndMatch: this.isMixAndMatch,
            losgData: this.filteredLosgsData,
            payLoad: this.payload,
            promoPanelEvents: {
                doLoading: this.props.promoPanelEvents && this.props.promoPanelEvents.doLoading,
                priceBarUpdates: this.props.promoPanelEvents && this.props.promoPanelEvents.priceBarUpdates,
                showSaveCartModal: this.props.promoPanelEvents && this.props.promoPanelEvents.showSaveCartModal,
            },
            promoPanelOptions: {
                autoExpandPromoSection: this.props.promoPanelOptions && this.props.promoPanelOptions.autoExpandPromoSection,
                displayCloserCoupon: this.props.promoPanelOptions && this.props.promoPanelOptions.displayCloserCoupon,
            },
            promotions: this.cartData.promotions,
            rewardModalEvent: this.showSavingRewardModal,
            savingsPromoFlags: this.savingsPromoFlags,
            showRewardModal: this.state.showRewardModal,
        });
    };
    ExpressCart.prototype.render = function () {
        var _this = this;
        var isWirelessApplicable = false;
        var losgs = {};
        var gnsession = Utils.getCookie('GNSESS');
        var tempName = gnsession ? JSON.parse(gnsession).FN : null;
        var userName = tempName ? tempName[0].toUpperCase() + tempName.substring(1) : null;
        this.isCommonCart = this.props && this.props.options && this.props.options.isCommonCartBsse;
        this.payload = cartUtils.getWirelessCart();
        var isPSC = this.cartData && this.cartData._cartCreationSource === 'PSC';
        if (this.payload) {
            this.cartData = this.payload ? this.payload.wirelessCart : null;
            isWirelessApplicable = !!this.cartData;
            losgs = isWirelessApplicable && this.cartData.losgs;
            this.externalOrderSourceType = wlsUtils.externalOrderSource(this.payload);
            this.filteredLosgsData = [];
            var losgList = Object.values(losgs);
            if (this.externalOrderSourceType) {
                var ctnNo_1 = '';
                var subscriberName_1 = {};
                losgList.forEach(function (losg) {
                    if (losg && losg.losgType && losg.losgType.toUpperCase() === 'NO_CHANGE') {
                        ctnNo_1 = (losg.extraParams && losg.extraParams.associatedCtn) || '';
                        if (losg.subscriberName) {
                            subscriberName_1 = losg.subscriberName || {};
                        }
                    }
                });
                losgList.forEach(function (losg) {
                    if (ctnNo_1 && losg && losg.primaryIndicator && losg.displayLine) {
                        losg.extraParams.associatedCtn = ctnNo_1;
                        if (subscriberName_1) {
                            losg.subscriberName = subscriberName_1;
                        }
                    }
                });
            }
            losgList.sort(wlsUtils.sortLogs);
            this.filteredLosgsData = losgList.filter(this.filterLosgs);
            this.sdpData = Utils.getSdpData(losgs, this.isMixAndMatch);
            this.flagExpressUpCapacityLink = this.payload.enableCapacityExpUpgrade;
            this.shippingDetails = this.payload.shippingDetails;
            this.newWireless = cartUtils.isNewWirelessPostpaidView();
            this.downPaymentInfo = wlsUtils.isDownPaymentRequired(this.filteredLosgsData, this.isExpressUp());
            this.isDownPaymentSeePricingDetails = wlsUtils.isPrescreenNegativePricingDetailsDisplay(this.payload);
            for (var _i = 0, _a = this.filteredLosgsData; _i < _a.length; _i++) {
                var losg = _a[_i];
                if (wlsUtils.isBYODAndEsim(losg)) {
                    this.isBYODAndEsim = true;
                }
            }
        }
        return (React.createElement("div", null, isWirelessApplicable && (React.createElement("div", { className: styles.wirelessCartView },
            this.isExpressUp() && React.createElement("div", null, this.expressUpView()),
            this.bogoModalBlock(),
            React.createElement(ui_components_1.Modal, { testId: utils_1.default('WLS', 'Modal', 'ConfirmRemove'), options: {
                    center: true,
                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.isRemoveModalOpen,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                    tabIndex: 0,
                }, events: {
                    onClose: function () {
                        _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.CART_PAGE);
                        _this.toggleRemoveModal();
                    },
                } },
                React.createElement(RemoveModalContent_1.default, { testId: utils_1.default('WLS', 'RemoveModalContent', 'ConfirmRemove'), events: {
                        onCancelClick: function () {
                            _this.toggleRemoveModal();
                        },
                        onRemoveClick: function () {
                            _this.toggleRemoveModal(true);
                        },
                    }, data: {
                        currentLOB: 'WLS',
                        isBundleinCart: Utils.isBundleinCart().isBundle,
                        isSonosinCart: Utils.IsSONOSAccessoryInCart(),
                    } })),
            this.acessFeeHelpBlock()))));
    };
    ExpressCart.prototype.expressUpView = function () {
        var _this = this;
        var _a, _b, _c;
        this.billCodesArry = [];
        this.expUpLineCount = 0;
        var enableCRPmessage = false;
        var deviceNameStyle = ((_a = this.eapFlowContext) === null || _a === void 0 ? void 0 : _a.simType) === 'eSIM' || ((_b = this.eapFlowContext) === null || _b === void 0 ? void 0 : _b.simType) === 'pSIM'
            ? styles.eapDeviceName
            : styles.expupItemname;
        var deviceInfoStyle = this.isBYODAndEsim ? styles.deviceInfoEsim : '';
        var isMDPPInsurance = Utils.isMDPPInsuranceSelected(this.filteredLosgsData);
        return (React.createElement(React.Fragment, null,
            React.createElement("section", { className: styles.expupSectionWhite },
                wirelessRTI.commonDeliveryMessage(this.cartSummaryCMSData.rtiCommonDeliveryText, this.payload),
                this.filteredLosgsData.map(function (losg, index) {
                    var _a, _b;
                    if (losg.losgType.toUpperCase() === 'CHANGE' && !losg.displayLine) {
                        return '';
                    }
                    if (losg.losgType.toUpperCase() !== 'CHANGE') {
                        if (_this.payload && Utils.isUPOrAALFlow() && ((_b = (_a = _this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.crpLater)) {
                            if (_this.getCRPMessageEligibility(losg)) {
                                enableCRPmessage = true;
                            }
                            if (enableCRPmessage && _this.isCRPStandAloneMessage) {
                                _this.props.crpEvents.crpStandaloneMessage();
                                _this.isCRPStandAloneMessage = false;
                            }
                        }
                        return (React.createElement("div", { key: "lineItem" + index, className: styles.expupProductInfo }, wlsUtils
                            .organizeLineItems(Object.values(losg.lineItems), _this.isMixAndMatch)
                            .map(function (lineItem, secindex) {
                            var _a, _b, _c, _d;
                            if (lineItem.uiDisplayLineItem &&
                                (lineItem.itemType.toUpperCase() === 'DEVICE' ||
                                    lineItem.itemType.toUpperCase() === 'ACCESSORY') &&
                                Utils.showEarlyUpgradeLineItem(lineItem.itemType, _this.earlyUpgradeAmount)) {
                                _this.expUpLineCount++;
                                if (_this.expUpLineCount > 1) {
                                    _this.expUpisMultiLine = true;
                                }
                                var lineDisplayHeaderText = _this.expressFlowLineNames(losg, index);
                                var deviceImgInfo = wlsUtils.getItemImage(lineItem);
                                var deviceInfo = _this.displayDeviceLine(lineItem, losg, _this.payload);
                                var modelName = lineItem && lineItem.hardGood && lineItem.hardGood.make && lineItem.hardGood.model
                                    ? lineItem.hardGood.make + " " + lineItem.hardGood.model
                                    : '';
                                var deviceLable = _this.displayEditCapacityModal(lineItem, losg, _this.payload.enableCommitmentViewDate, modelName, wlsUtils.getSubscriberNumber(losg), _this.cartSummaryCMSData.editDeviceLabel);
                                var editUrl = wlsUtils.getEditUrl(_this.cartData, _this.cartMetaData, losg);
                                var planInfo = Utils.getPlanInfo(losg);
                                var isAccessoryLineItem = lineItem.itemType.toUpperCase() === 'ACCESSORY';
                                return (React.createElement(React.Fragment, { key: "lineItemInfo" + index + "_" + secindex },
                                    React.createElement("div", null,
                                        _this.expUpLineCount > 1 && lineItem.itemType.toUpperCase() === 'DEVICE' && (React.createElement("div", { className: wlsUtils.multiUpCheck() ? styles.expupMixcartDivider : styles.expupDivider })),
                                        _this.expUpLineCount > 1 && lineItem.itemType.toUpperCase() === 'ACCESSORY' && (React.createElement("div", { className: styles.expAccessoryDivider })),
                                        lineItem.itemType.toUpperCase() === 'DEVICE' && wlsUtils.multiUpCheck() &&
                                            React.createElement(React.Fragment, null,
                                                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText.split('-')[0] }, options: {
                                                        className: ([styles.expupMixcartLinename, styles.blockView].join(' ')),
                                                        tabIndex: 0,
                                                    }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) }),
                                                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText.split('-')[1] }, options: {
                                                        className: ([styles.expupMixcartCta, styles.blockView].join(' ')), tabIndex: 0,
                                                    }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) })),
                                        lineItem.itemType.toUpperCase() === 'DEVICE' &&
                                            wirelessRTI.displayRtiOosDeviceMessage(losg, _this.filteredLosgsData.length, _this.editLineForPscCustomers, _this.removeLineForPscCustomers, deviceLable, _this.showEditOptions, _this.payload, editUrl),
                                        lineItem.itemType.toUpperCase() === 'ACCESSORY' &&
                                            wirelessRTI.displayRtiOosAccessoryMessage(lineItem, losg, _this.editLineForPscCustomers, _this.changeAccessoryQuantity, editUrl),
                                        React.createElement("div", { className: [styles.expupLineinfo, styles.displayFlex, styles.expupDevicename,
                                                isAccessoryLineItem ? styles.accessoryTileContainer : ''].join(' ') },
                                            (deviceImgInfo === null || deviceImgInfo === void 0 ? void 0 : deviceImgInfo.imageUrl) &&
                                                _this.getDeviceImgContainer(deviceImgInfo, isAccessoryLineItem ? [styles.deviceImg, styles.accessoryExpImg].join(' ') :
                                                    styles.deviceImg, styles.simImg),
                                            React.createElement("div", { className: [styles.lineItemName, styles.expUpLineitemnameWidth].join(' ') },
                                                React.createElement("div", { className: styles.displayHeader },
                                                    !_this.isBYODAndEsim && lineItem.itemType.toUpperCase() === 'DEVICE' &&
                                                        !wlsUtils.multiUpCheck() && !_this.isAALFlow && (React.createElement("span", null,
                                                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText.split('-')[0] }, options: {
                                                                className: styles.expupLinename, tabIndex: 0,
                                                            }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) }),
                                                        React.createElement("br", null),
                                                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText.split('-')[1] }, options: {
                                                                className: styles.expupLinename,
                                                            }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) }))),
                                                    lineItem.itemType.toUpperCase() === 'DEVICE' && !_this.isBYODAndEsim &&
                                                        (_this.isAALFlow || wlsUtils.multiUpCheck()) &&
                                                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText }, options: {
                                                                className: [styles.expupLinename, _this.isAALFlow ? '' : styles.flexView]
                                                                    .join(' '), tabIndex: 0,
                                                            }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) }),
                                                    !_this.isUnauthAccess && React.createElement(React.Fragment, null, ((_this.isAALFlow || losg.losgType.toUpperCase() === 'UP') &&
                                                        lineItem.itemType.toUpperCase() === 'ACCESSORY') ?
                                                        _this.showEditAndRemove(losg, _this.cartData.qualifierPlanName, _this.filteredLosgsData.length, index + 1, null, true, lineItem) :
                                                        _this.showEditAndRemove(losg, _this.cartData.qualifierPlanName, _this.filteredLosgsData.length, index + 1, lineItem))),
                                                !_this.isUnauthAccess && losg.losgType.toUpperCase() === 'UP' &&
                                                    lineItem.itemType.toUpperCase() !== 'ACCESSORY' &&
                                                    _this.cartData.upgradeAnotherDeviceEligible &&
                                                    _this.showUpgradeLink(losg),
                                                React.createElement("div", { className: Utils.isAppleWatchFlow(losg) ? [deviceInfoStyle, styles.postpaidLineItem].join(' ') : deviceInfoStyle },
                                                    lineItem.itemType.toUpperCase() === 'DEVICE' &&
                                                        !Utils.isAppleWatchFlow(losg) && (React.createElement("span", { className: deviceNameStyle }, deviceInfo)),
                                                    lineItem.itemType.toUpperCase() === 'DEVICE' &&
                                                        Utils.isAppleWatchFlow(losg) && (React.createElement("span", { className: deviceNameStyle },
                                                        "Plan: ", planInfo === null || planInfo === void 0 ? void 0 :
                                                        planInfo.displayName)),
                                                    lineItem.itemType.toUpperCase() === 'DEVICE' &&
                                                        wlsUtils.ischangeRatePlanFlow().isCrpCustomer &&
                                                        _this.displayChangeRatePlanLineItem(),
                                                    lineItem.itemType.toUpperCase() === 'ACCESSORY' &&
                                                        _this.displayAccessoryLineItem(losg, lineItem)),
                                                !_this.isUnauthAccess && lineItem.itemType.toUpperCase() !== 'ACCESSORY' &&
                                                    React.createElement(React.Fragment, null, // android watch show plan name
                                                    ((cartUtils.checkShareCartEligibilityForAndroid() || _this.isBYODAndEsim)
                                                        && !Utils.isAppleWatchFlow(losg)) &&
                                                        React.createElement("div", { className: styles.lineItems },
                                                            React.createElement("span", { className: styles.activationPlanname },
                                                                !_this.isBYODAndEsim && React.createElement("b", null, "Plan:"),
                                                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('WRLS', 'Plan', 'Info'), data: { isDecodingRequired: false, text: planInfo === null || planInfo === void 0 ? void 0 : planInfo.displayName } })),
                                                            _this.isBYODAndEsim &&
                                                                React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "plan"), data: { billingNote: '/mo.', price: planInfo === null || planInfo === void 0 ? void 0 : planInfo.price }, options: {
                                                                        className: styles.lineItem,
                                                                        decimalPoints: 2, type: PriceContainerProps_1.PricingType.XSMALL,
                                                                    } }))),
                                                Utils.isAppleWatchFlow(losg) &&
                                                    React.createElement("span", { className: styles.activationPlanname }, deviceInfo),
                                                !_this.isUnauthAccess && !Utils.isEnableValidateInventory() && (React.createElement("div", { className: styles.expupDeliveryDate }, _this.state.showEstDeliveryDate &&
                                                    _this.showEstDelivery &&
                                                    _this.setDeliveryDates(lineItem.billingCode))),
                                                !_this.isUnauthAccess &&
                                                    React.createElement("div", { className: styles.flexView },
                                                        _this.payload.enableDisplayHylaSharedComponent &&
                                                            lineItem.itemType.toUpperCase() === 'DEVICE' &&
                                                            !((_b = (_a = cartUtils.getDeviceDetailsFromLOSG(losg.id)) === null || _a === void 0 ? void 0 : _a.contractDetails) === null || _b === void 0 ? void 0 : _b.payupAmount) && (React.createElement("div", { className: styles.expupTradeinSection }, _this.renderTradeInComponent(losg, lineItem, true))),
                                                        _this.enableWirelessInsurance(losg) &&
                                                            lineItem.itemType.toUpperCase() === 'DEVICE' && (React.createElement("div", { className: styles.expupTradeinSection }, _this.renderInsurance(losg, lineItem, isMDPPInsurance)))))),
                                        !_this.isUnauthAccess &&
                                            React.createElement("div", { className: styles.blockView },
                                                _this.payload.enableDisplayHylaSharedComponent &&
                                                    lineItem.itemType.toUpperCase() === 'DEVICE' &&
                                                    !((_d = (_c = cartUtils.getDeviceDetailsFromLOSG(losg.id)) === null || _c === void 0 ? void 0 : _c.contractDetails) === null || _d === void 0 ? void 0 : _d.payupAmount) && (React.createElement("div", { className: styles.expupTradeinSection }, _this.renderTradeInComponent(losg, lineItem, true))),
                                                _this.enableWirelessInsurance(losg) &&
                                                    lineItem.itemType.toUpperCase() === 'DEVICE' && (React.createElement("div", { className: styles.expupTradeinSection }, _this.renderInsurance(losg, lineItem, isMDPPInsurance)))))));
                            }
                            else {
                                return React.createElement(React.Fragment, null, " ");
                            }
                        })));
                    }
                    else {
                        return '';
                    }
                })),
            this.isUnauthAccess && React.createElement("section", { className: styles.expupSectionWhite },
                React.createElement(UnauthAccess_1.default, null)),
            !this.isUnauthAccess && React.createElement(React.Fragment, null,
                this.renderUpgradeCta(),
                React.createElement("section", { className: styles.expupSectionWhite },
                    React.createElement("div", { className: this.isBYODAndEsim ? styles.expupDividerEsim : styles.expupDividerDue }),
                    wlsUtils.ischangeRatePlanFlow().isCrpCustomer &&
                        Object.values((_c = this.cartData) === null || _c === void 0 ? void 0 : _c.losgs).map(function (losg) {
                            var _a;
                            if (((_a = losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'CHANGE' &&
                                (losg.parentLosgId === undefined || losg.parentLosgId === null)) {
                                return (React.createElement(React.Fragment, null,
                                    React.createElement(WirelessCRP_1.default, { losg: losg, events: { onEdit: _this.props.events.onEdit }, wlsCMSData: _this.cartSummaryCMSData }),
                                    React.createElement("div", { className: styles.expupDivider })));
                            }
                        }),
                    this.expupDueTodaySection(),
                    " ",
                    this.expupDueMonthlySection(),
                    this.expupDueOnFirstBillSection(this.isBYODAndEsim),
                    this.savingsPromoFlags && this.savingsPromoFlags.savingsPromoComponentDisplay && (React.createElement("div", { className: styles.savingsPromoExpup },
                        this.expUpShowHideLink(),
                        " ",
                        this.showNewSavingAndPromo(),
                        ' '))))));
    };
    ExpressCart.prototype.expupDueTodaySection = function () {
        var losgsInfo = this.filteredLosgsData.filter(wlsUtils.filterLosgs);
        var isAndroidDevice = cartUtils.checkShareCartEligibilityForAndroid();
        var isPrePreOrder = cartUtils.isPrePreOrder();
        return (React.createElement("div", { className: [styles.expupDueamount, styles.expupDuetodayContainer].join(' ') },
            cartUtils.enableBillComponent() && React.createElement("div", { className: styles.billestimatorMessage },
                React.createElement("span", null, this.cartSummaryCMSData.billEstimatorHeadingText),
                " ",
                React.createElement("br", null),
                "Your upcoming bill will be different from your ongoing bills and may include any one-time charges and partial-month charges and/or credits. You\u2019ll get a chance to see a breakdown of your bill estimates before you submit your order."),
            React.createElement(DueAmount_1.default, { data: {
                    duePrice: this.cartData.totalLobDueToday,
                    dueText: isPrePreOrder ? 'Due at purchase' : (this.payload.orderPriceInfo.taxCalculated
                        ? this.cartSummaryCMSData.expupDueTodayLabel
                        : this.cartSummaryCMSData.expupDueTodayLabel + '*'),
                    isPriceNegative: false,
                    showPrice: true,
                } }),
            this.props.options && this.props.options.isExpandView
                && !(isAndroidDevice || Utils.isAppleWatchFlow()) && (React.createElement("div", { className: styles.expupExpandview },
                this.getLosgLineItem(losgsInfo, 'DueToday'),
                this.getPayupPayoffFromDeviceLineitem(losgsInfo),
                React.createElement("div", { className: [styles.lineItemContainer, styles.expupSalestax].join(' ') }, this.getSalesTax(this.payload.orderPriceInfo.tax, this.payload.orderPriceInfo)),
                this.expUpEarlyUpgrade()))));
    };
    ExpressCart.prototype.expupDueMonthlySection = function () {
        var _a;
        var losgsInfo = this.filteredLosgsData.filter(wlsUtils.filterLosgs);
        var changeLosgs = wlsUtils.filterOtherChangeLosgs((_a = this.cartData) === null || _a === void 0 ? void 0 : _a.losgs);
        if (changeLosgs && changeLosgs.length > 0) {
            changeLosgs.forEach(function (cLosg) { return (losgsInfo.push(cLosg)); });
            this.isCrpUpgrade = true;
        }
        var dividerStyle = styles.expupDividerExpanded;
        return (React.createElement("div", { className: styles.expupDueamount },
            React.createElement("div", { className: dividerStyle }),
            React.createElement(DueAmount_1.default, { data: {
                    duePrice: this.cartData.totalLobDueMonthly,
                    dueText: this.cartSummaryCMSData.expupDueMonthlyLabel,
                    isPriceNegative: false,
                    showPrice: true,
                } }),
            this.props.options && this.props.options.isExpandView && (React.createElement("div", { className: styles.expupExpandview },
                this.getLosgLineItem(losgsInfo, 'DueMonthly'),
                !this.isCrpUpgrade && this.getPlanDetails(),
                this.expupOther(this.payload)))));
    };
    ExpressCart.prototype.expupDueOnFirstBillSection = function (isBYODAndEsim) {
        var dueOnFirstBill = this.cartData.totalLob1stBill ? this.cartData.totalLob1stBill : 0;
        if (Number(dueOnFirstBill) === 0 && isBYODAndEsim) {
            return React.createElement(React.Fragment, null);
        }
        var losgsInfo = this.filteredLosgsData.filter(wlsUtils.filterLosgs);
        var dividerStyle = styles.expupDividerExpanded;
        return (React.createElement("div", { className: styles.expupDueamount },
            React.createElement("div", { className: dividerStyle }),
            React.createElement(DueAmount_1.default, { data: {
                    duePrice: dueOnFirstBill,
                    dueText: this.cartSummaryCMSData.expupDueOnFirstBillLabel,
                    isPriceNegative: false,
                    showPrice: true,
                } }),
            this.props.options && this.props.options.isExpandView && (React.createElement("div", { className: styles.expupExpandview }, this.getLosgLineItem(losgsInfo, 'DueOnFirstBill'))),
            React.createElement("div", { className: dividerStyle }),
            React.createElement("div", { className: styles.font11px },
                React.createElement("span", null, this.cartSummaryCMSData.expupPlusTaxesLabel),
                "\u00A0",
                React.createElement("span", null, this.showExpUpLegal()))));
    };
    ExpressCart.prototype.showRetailerOffer = function (losg) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (this.isCrpUpgrade && ((_a = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'UP') {
            this.changeLosg = wlsUtils.findChangeLosg((_b = this.cartData) === null || _b === void 0 ? void 0 : _b.losgs, (_c = losg === null || losg === void 0 ? void 0 : losg.extraParams) === null || _c === void 0 ? void 0 : _c.associatedCtn);
            (_e = ((_d = this.changeLosg) === null || _d === void 0 ? void 0 : _d.promotionReferences)) === null || _e === void 0 ? void 0 : _e.map(function (promo) {
                (losg === null || losg === void 0 ? void 0 : losg.promotionReferences).push(promo);
            });
        }
        var retailer = (_g = ((_f = this.cartData) === null || _f === void 0 ? void 0 : _f.promotions)) === null || _g === void 0 ? void 0 : _g.map(function (promo) {
            if ((promo === null || promo === void 0 ? void 0 : promo._dealerPromotion) && (promo.promotionType.toUpperCase() !== 'REWARD')) {
                return React.createElement(RetailerOffer_1.default, { isReawardCard: false, losg: losg, promotion: promo });
            }
        });
        return React.createElement("div", null, retailer);
    };
    ExpressCart.prototype.getLosgLineItem = function (losgsInfo, itemCategory) {
        var _this = this;
        if (losgsInfo && itemCategory) {
            return losgsInfo.map(function (losg, index) {
                var _a, _b, _c, _d, _e;
                var lineDisplayHeaderText = _this.expressFlowLineNames(losg, index);
                var isTrue = _this.expUpFilterLineItems(losg);
                var dueItemCategory = [];
                if (itemCategory.toUpperCase() === 'DUEMONTHLY') {
                    dueItemCategory = _this.expUpDueMonthlyItems;
                    if (_this.isCrpUpgrade && ((_a = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'UP') {
                        var changeLosg = wlsUtils.findChangeLosg((_b = _this.cartData) === null || _b === void 0 ? void 0 : _b.losgs, (_c = losg === null || losg === void 0 ? void 0 : losg.extraParams) === null || _c === void 0 ? void 0 : _c.associatedCtn);
                        if (changeLosg) {
                            _this.expUpFilterLineItems(changeLosg);
                            dueItemCategory = dueItemCategory.concat(_this.expUpDueMonthlyItems);
                        }
                    }
                }
                else if (itemCategory.toUpperCase() === 'DUETODAY') {
                    dueItemCategory = _this.expUpDueTodayItems;
                }
                else if (itemCategory.toUpperCase() === 'DUEONFIRSTBILL') {
                    dueItemCategory = _this.expUpDueOnFirstBillItems;
                }
                if (isTrue && dueItemCategory.length > 0) {
                    var isESimWithAcc = ((_d = losg === null || losg === void 0 ? void 0 : losg.losgType) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === 'ACC' && ((_e = _this.eapFlowContext) === null || _e === void 0 ? void 0 : _e.simType) === 'eSIM';
                    return (React.createElement("div", { key: "" + losg.id + index, className: styles.expupline },
                        (_this.expUpLineCount > 1 || (_this.isCrpUpgrade && itemCategory.toUpperCase() === 'DUEMONTHLY')) &&
                            !isESimWithAcc && (React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText }, options: { className: _this.isCrpUpgrade ? styles.expupLineHeaderCrp :
                                    styles.expupLineHeader } })),
                        _this.isCrpUpgrade && (React.createElement("br", null)),
                        _this.expUpDisplayLineItems(dueItemCategory, losg, index + 1),
                        itemCategory.toUpperCase() === 'DUEMONTHLY' && _this.showRetailerOffer(losg)));
                }
                return React.createElement(React.Fragment, null, " ");
            });
        }
        return React.createElement(React.Fragment, null, " ");
    };
    ExpressCart.prototype.showExpUpLegal = function () {
        var _this = this;
        var isSmartDevice = cartUtils.checkShareCartEligibilityForAndroid();
        if ((this.expUpdueTodayLegal && this.expUpdueTodayLegal.showLegal) ||
            (this.expUpdue1stBillLegal && this.expUpdue1stBillLegal.showLegal)) {
            var linkText_1 = this.expUpdueTodayLegal.shortdesclinktext || this.expUpdue1stBillLegal.shortdesclinktext;
            return (React.createElement(React.Fragment, null,
                React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('expupSeeDetailsLink', 'legalmodal'), className: styles.expupLegallink, 
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick: function () {
                        _this.showExpUpLegalModal(true, linkText_1);
                    } }, linkText_1),
                React.createElement(ui_components_1.Modal, { testId: "ExpUp_Modal_Details", options: {
                        center: true,
                        className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                        show: this.state.showExpUpLegal,
                        showClose: true,
                        size: ModalProps_1.ModalSizes.MEDIUM,
                        tabIndex: 0,
                    }, events: {
                        onClose: function () {
                            _this.showExpUpLegalModal(false, 'Close');
                        },
                    } },
                    React.createElement("div", { className: styles.legalContainer, style: !!isSmartDevice ? { pointerEvents: 'none', cursor: 'default', textDecoration: 'none' } : {} },
                        React.createElement("div", { className: CartConfiguration_scss_1.mb10 },
                            React.createElement(ui_components_1.Label, { data: { text: 'The legal stuff' }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING24, className: styles.legalHeading } })),
                        this.expUpdueTodayLegal.showLegal && (React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { text: this.expUpdueTodayLegal.modaltitle }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING18, className: styles.legalHeading } }),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: this.expUpdueTodayLegal.longtext } }))),
                        this.expUpdue1stBillLegal.showLegal && (React.createElement("div", null,
                            React.createElement(ui_components_1.Label, { data: { text: this.expUpdue1stBillLegal.modaltitle }, options: { size: LabelProps_1.LabelSizes.SMALLHEADING18, className: styles.legalHeading } }),
                            React.createElement("p", { dangerouslySetInnerHTML: { __html: this.expUpdue1stBillLegal.longtext } })))))));
        }
        return React.createElement(React.Fragment, null, " ");
    };
    ExpressCart.prototype.expUpDisplayLineItems = function (itemList, losg, lineIndex) {
        var _this = this;
        if (itemList && itemList.length > 0) {
            return wlsUtils.organizeLineItems(itemList, this.isMixAndMatch).map(function (lineItem, index) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                var lineItemPriceData = wlsUtils.getLineItemPriceData(lineItem, _this.isMixAndMatch, true, _this.isCrpUpgrade);
                lineItemPriceData.lineItemPrice.billingNote = '';
                var mnmPlanDetails = losg.mnmPlanItems;
                var subscriber = losg.subscriberName;
                var imageStyle = cartUtils.isAppreciationOfferPresent()
                    ? [icons.cccIconCart, icons.cccIconCartSavingsAppreciation32].join(' ')
                    : [icons.cccIconCart, icons.cccIconCartSignatureBookmark].join(' ');
                var promoRef = (_a = mnmPlanDetails === null || mnmPlanDetails === void 0 ? void 0 : mnmPlanDetails.MnM) === null || _a === void 0 ? void 0 : _a.mnmPromotionReferences;
                var isSignatureDiscountPresent = false;
                if (promoRef) {
                    promoRef.forEach(function (promoReference, promoIndex) {
                        var _a;
                        var promotion = _this.cartData.promotions.find(function (promo) { return promo.id === promoReference; });
                        if (promotion &&
                            (promotion.promotionCategory === 'iruPlanDiscount' ||
                                ((_a = promotion.discountCategory) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'noncontractual')) {
                            isSignatureDiscountPresent = true;
                        }
                    });
                }
                var isWaivedActivationFee = ((_b = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fees) === null || _b === void 0 ? void 0 : _b.waivedIndicator) === true && ((_d = (_c = lineItem === null || lineItem === void 0 ? void 0 : lineItem.fees) === null || _c === void 0 ? void 0 : _c.waivedReason) === null || _d === void 0 ? void 0 : _d.toUpperCase()) === 'FAN';
                var displayIcon = false;
                if (lineItem.itemType.toUpperCase() !== 'DEVICE' && _this.payload.enableSignatureEnhancedExperience &&
                    !CartUtilFunctions_1.isFNIntentPresent() && !cartUtils.isFNUserWithConsumerLine()) {
                    displayIcon =
                        lineItem.fees &&
                            (((_e = lineItem.fees.feeId) === null || _e === void 0 ? void 0 : _e.toUpperCase()) === 'ACT' ||
                                ((_f = lineItem.fees.feeId) === null || _f === void 0 ? void 0 : _f.toUpperCase()) === 'ACTIVATION_FEE' ||
                                ((_g = lineItem.fees.feeId) === null || _g === void 0 ? void 0 : _g.toUpperCase()) === 'UPG')
                            ? isWaivedActivationFee
                            : (((_h = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _h === void 0 ? void 0 : _h.toUpperCase()) === 'SHAREDDATAFEATURE' ||
                                ((_j = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _j === void 0 ? void 0 : _j.toUpperCase()) === 'SHAREDDATAGROUP' ||
                                ((_k = lineItem === null || lineItem === void 0 ? void 0 : lineItem.itemType) === null || _k === void 0 ? void 0 : _k.toUpperCase()) === 'VOICEPLAN') &&
                                isSignatureDiscountPresent
                                ? true
                                : false;
                }
                return (React.createElement("div", { key: "expuplineItem" + index },
                    React.createElement("div", { className: styles.expupLineitemContainer },
                        React.createElement("div", { className: [styles.lineItems, styles.expuplineItem].join(' ') },
                            React.createElement("div", { tabIndex: 0, className: styles.lineItemName },
                                displayIcon && !cartUtils.isSMBCustomer() && !(Utils === null || Utils === void 0 ? void 0 : Utils.isAppleWatchFlow(losg)) && (React.createElement("span", { className: styles.iconBookmark32 },
                                    React.createElement("i", { "aria-label": "Icon", className: imageStyle }))),
                                lineItem.itemType.toUpperCase() !== 'DEVICE' &&
                                    !(lineItem.itemType.toUpperCase() === 'ACCESSORY') && (React.createElement(ui_components_1.Label, { data: {
                                        isDecodingRequired: false,
                                        text: Utils.getLineItemName(lineItem, false, _this.isCommonCart, _this.isExpressUp(), _this.cartSummaryCMSData, _this.cartData),
                                    }, options: { className: styles.itemName } })),
                                !(Utils === null || Utils === void 0 ? void 0 : Utils.isAppleWatchFlow(losg)) && lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE' &&
                                    mnmPlanDetails &&
                                    mnmPlanDetails.MnM &&
                                    mnmPlanDetails.MnM.mnmPromotionReferences &&
                                    mnmPlanDetails.MnM.mnmPromotionReferences.length > 0 && (React.createElement(React.Fragment, null,
                                    React.createElement("span", { className: styles.legalLinkSpace }),
                                    React.createElement(TextTooltip_1.default, { data: { linkText: 'See discounts' }, events: { doLoading: _this.props.events.doLoading }, options: {
                                            isSignatureFlagEnabled: _this.payload.enableSignatureEnhancedExperience,
                                            losgId: lineIndex === null || lineIndex === void 0 ? void 0 : lineIndex.toString(),
                                            mnmPlanDetails: mnmPlanDetails,
                                            promotions: _this.cartData.promotions,
                                            subscriber: subscriber,
                                        } }))),
                                lineItem.itemType.toUpperCase() === 'DEVICE' && !_this.externalOrderSourceType && (React.createElement("span", { className: styles.itemName }, wlsUtils.getExpUpLineItemName(lineItem))),
                                _this.accessoryModal(lineItem, losg, true, true)),
                            _this.showlineItemPrice(lineItem, true, false, false, _this.isCrpUpgrade)),
                        _this.showInstallmentMessage(lineItem, losg),
                        _this.showWaivedText(lineItem),
                        lineItem.itemType.toUpperCase() === 'DEVICE' && _this.dueMonthlyCrpLaterMessage(losg, lineItem)),
                    _this.showPromotions(lineItem)));
            });
        }
        return React.createElement(React.Fragment, null, " ");
    };
    ExpressCart.prototype.expUpFilterLineItems = function (losg) {
        var _this = this;
        this.expUpDueTodayItems = [];
        this.expUpDueMonthlyItems = [];
        this.expUpDueOnFirstBillItems = [];
        if (losg && losg.lineItems) {
            Object.values(losg.lineItems).forEach(function (lineItem, index) {
                var _a, _b;
                var losgLineItems = lineItem;
                if ((losgLineItems && losgLineItems.uiDisplayLineItem) ||
                    (losgLineItems && losgLineItems.itemType.toUpperCase() === 'SHAREDDATAFEATURE' &&
                        losg.losgType.toUpperCase() === 'CHANGE')) {
                    var itemType = losgLineItems.itemType.toUpperCase();
                    if (losgLineItems && losgLineItems.uiDisplayLineItem &&
                        itemType === 'DEVICE' &&
                        losgLineItems.contractDetails &&
                        losgLineItems.contractDetails.contractType &&
                        (losgLineItems.contractDetails.contractType.toUpperCase() === 'NOCOMMIT' ||
                            losgLineItems.contractDetails.contractType.toUpperCase() === 'REGULAR')) {
                        _this.expUpDueTodayItems.push(losgLineItems);
                    }
                    else if (losgLineItems && losgLineItems.uiDisplayLineItem &&
                        (itemType === 'ACCESSORY' || itemType === 'PAYUP' || itemType === 'PAYOFF' || itemType === 'DOWNPAYMENT')) {
                        _this.expUpDueTodayItems.push(losgLineItems);
                    }
                    else if ((itemType === 'UPGRADEFEE' || itemType === 'ACTIVATION_FEE') &&
                        losgLineItems.price &&
                        ((_b = (_a = losgLineItems === null || losgLineItems === void 0 ? void 0 : losgLineItems.price) === null || _a === void 0 ? void 0 : _a.priceType) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'NRC') {
                        _this.expUpDueOnFirstBillItems.push(losgLineItems);
                    }
                    else {
                        if ((itemType !== 'PAYUP' &&
                            itemType !== 'PAYOFF' &&
                            itemType !== 'SHAREDDATAGROUP' &&
                            itemType !== 'SHAREDDATAFEATURE') ||
                            (itemType === 'SHAREDDATAFEATURE' && _this.isMixAndMatch) ||
                            (itemType === 'SHAREDDATAFEATURE' && losg.losgType.toUpperCase() === 'CHANGE')) {
                            _this.expUpDueMonthlyItems.push(losgLineItems);
                        }
                    }
                }
            });
            return true;
        }
        return false;
    };
    ExpressCart.prototype.getPlanDetails = function () {
        return (React.createElement(React.Fragment, null,
            !(this.isMixAndMatch || cartUtils.isFNCarribeanUser()) && this.displayPlanDetails(),
            !this.isMixAndMatch &&
                this.displayPlanDetailsinModal(this.payload) &&
                this.renderPlanModalDetails(this.cartData)));
    };
    ExpressCart.prototype.expUpEarlyUpgrade = function () {
        var pricingType = PriceContainerProps_1.PricingType.XSMALL;
        this.earlyUpgradeAmount = (this.wlsEarlyUpgradePriceFeature && this.cartData.earlyUpgradeAmount) || 0;
        var upgradeOptionType = (this.cartData.upgradeOption && this.cartData.upgradeOption.type) || 'NONE';
        var upgradeOptionTypeTooltipTxt = '';
        if (upgradeOptionType.toUpperCase() === 'PAYOFF') {
            upgradeOptionTypeTooltipTxt = this.cartSummaryCMSData.payOffInstallmentPlanLabel;
        }
        else if (upgradeOptionType.toUpperCase() === 'PAYUP') {
            upgradeOptionTypeTooltipTxt = this.cartSummaryCMSData.payUpInstallmentPlanLabel;
        }
        else {
            upgradeOptionTypeTooltipTxt = '';
        }
        var wirelessUpgradeDisplayName = this.cartData.wirelessUpgradeDisplayName;
        if (this.earlyUpgradeAmount > 0 && wirelessUpgradeDisplayName) {
            return (React.createElement("div", null,
                React.createElement("div", { className: [styles.lineItems, styles.lineItemContainer].join(' ') },
                    React.createElement("div", { tabIndex: 0, className: styles.lineItemName },
                        React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: wirelessUpgradeDisplayName }, options: { className: styles.itemName } }),
                        upgradeOptionTypeTooltipTxt && (React.createElement(components_1.Tooltip, { content: React.createElement("span", { dangerouslySetInnerHTML: { __html: upgradeOptionTypeTooltipTxt } }), testId: utils_1.default('Tooltip', 'WRLS_UpgradeOptionType'), className: CartConfiguration_scss_1.ducTooltip, position: "top", boxWidth: 300, offset: 75, zIndex: true },
                            React.createElement(components_1.IconSvg, { size: 16, colorClass: "color-ui-black", svgNodeStr: Utils.GET_ICON_SVG.QUESTION })))),
                    React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "EarlyUpgrade"), data: { billingNote: '', price: this.earlyUpgradeAmount }, options: { className: styles.lineItem, decimalPoints: 2, type: pricingType } }))));
        }
        return React.createElement(React.Fragment, null, " ");
    };
    ExpressCart.prototype.expressFlowLineNames = function (losg, index) {
        if (losg) {
            var divider = (this.isCrpUpgrade) ? ' : ' : ' - ';
            var ctnNumber = losg && losg.extraParams && losg.extraParams.associatedCtn;
            var lineNumber = ctnNumber
                ? (this.expUpisMultiLine && !wlsUtils.multiUpCheck())
                    ? " " + (index + 1) + (" " + divider) + ("" + Utils.formatPhoneNumberWithDot(ctnNumber, true))
                    : "" + divider + ("" + Utils.formatPhoneNumberWithDot(ctnNumber, true))
                : index + 1;
            var lineDisplayHeaderText = Utils.getDeviceHeader(lineNumber, losg, index + 1, this.externalOrderSourceType, this.eapFlowContext, this.cartSummaryCMSData, this.payload, this.isAALFlow, this.isMixedCart, this.isCrpUpgrade);
            if ((losg.losgType.toUpperCase() === 'AL' && !this.isAALFlow) ||
                (losg.losgType.toUpperCase() === 'AL' && wlsUtils.multiUpCheck())) {
                return "NEW " + lineDisplayHeaderText;
            }
            else {
                return "" + lineDisplayHeaderText;
            }
        }
        else {
            return '';
        }
    };
    ExpressCart.prototype.showUpgradeLink = function (losg) {
        var _this = this;
        var losgId = losg.id;
        if (this.cartData._cartCreationSource === 'PSC') {
            return (React.createElement("div", null,
                this.isUnauthAccess && React.createElement("span", null, this.cartSummaryCMSData.upgradeLine),
                !this.isUnauthAccess &&
                    React.createElement(components_1.Link, { kind: "textPlain", testId: utils_1.default('Cart', 'Link', 'Add another line'), className: CartConfiguration_scss_1.rennyCommonLink, 
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick: function () {
                            _this.reportingService.fireLinkClickWithOutPageLoad('Upgrade a different line', ReportingService_1.PageUrls.CART_LINE_SELECTION);
                            window.location.href = "/buy/postpaid/line-selection?edit=" + losgId;
                        } }, this.cartSummaryCMSData.upgradeLine)));
        }
        else {
            return React.createElement(React.Fragment, null, " ");
        }
    };
    ExpressCart.prototype.setDeliveryDates = function (billCode) {
        var _a, _b;
        var deliveryDate = '';
        if (billCode && this.state.showEstDeliveryDate && this.billCodeRespObj[billCode] && !wlsUtils.isBYODAndEsim()) {
            var dateObj = this.billCodeRespObj[billCode];
            var deliveryLabel = this.cartSummaryCMSData.expupEstDateLabel;
            if (((_a = dateObj === null || dateObj === void 0 ? void 0 : dateObj.deliveryDates) === null || _a === void 0 ? void 0 : _a.dateFrom) && ((_b = dateObj === null || dateObj === void 0 ? void 0 : dateObj.deliveryDates) === null || _b === void 0 ? void 0 : _b.dateTo)) {
                if (dateObj.deliveryDates.dateFrom === dateObj.deliveryDates.dateTo) {
                    if (dateObj.deliveryDates.dateFrom.split(',') !== undefined &&
                        dateObj.deliveryDates.dateFrom.split(',').length > 0) {
                        return deliveryLabel + " " + dateObj.deliveryDates.dateFrom.split(',')[0];
                    }
                }
                if (dateObj.deliveryDates.dateFrom.split(',') !== undefined &&
                    dateObj.deliveryDates.dateFrom.split(',').length > 0 &&
                    dateObj.deliveryDates.dateTo.split(',') !== undefined &&
                    dateObj.deliveryDates.dateTo.split(',').length > 0) {
                    deliveryDate = deliveryLabel + "\n                    " + dateObj.deliveryDates.dateFrom.split(',')[0] + " - " + dateObj.deliveryDates.dateTo.split(',')[0];
                }
            }
        }
        return deliveryDate;
    };
    ExpressCart.prototype.expupOther = function (payload) {
        var addOnDueAmount = 0;
        if (!Utils.IsBsseFlow() && payload) {
            addOnDueAmount = payload.addOnDueAmount ? payload.addOnDueAmount : 0;
        }
        if (addOnDueAmount !== 0) {
            return (React.createElement("section", null, this.cartSummaryCMSData.titleATTFees && !Utils.IsBsseFlow() && this.showAttAdminFees(payload)));
        }
        else {
            return React.createElement(React.Fragment, null, " ");
        }
    };
    ExpressCart.prototype.displayLineItems = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null, this.filteredLosgsData.map(function (losg, index) {
            if (losg.losgType.toUpperCase() === 'CHANGE' && !losg.displayLine) {
                return '';
            }
            var ctnNumber = losg && losg.extraParams && losg.extraParams.associatedCtn;
            var lineNumber = ctnNumber ? ': ' + ("" + Utils.formatPhoneNumberWithDot(ctnNumber)) : index + 1;
            var editUrl = wlsUtils.getEditUrl(_this.cartData, _this.cartMetaData, losg);
            var lineDisplayHeaderText = Utils.getDeviceHeader(lineNumber, losg, ++index, _this.externalOrderSourceType, _this.eapFlowContext, _this.cartSummaryCMSData, _this.payload, _this.isAALFlow, _this.isMixedCart);
            if (losg.losgTaxInfo) {
                losg.losgTaxInfo.lineName = lineDisplayHeaderText;
            }
            var lineDisplayName = losg.losgType.toUpperCase() !== 'CHANGE' &&
                !_this.isExpressUp() &&
                !_this.isCommonCart && (React.createElement("div", { className: _this.newWireless ? styles.lineEditremoveContainer : '' },
                React.createElement(ui_components_1.Label, { data: { isDecodingRequired: false, text: lineDisplayHeaderText }, options: { className: _this.newWireless ? styles.linename : styles.line }, testId: utils_1.default('WRLS', 'Device', "Header_" + index) })));
            var imageContainer;
            var deviceName;
            var retalPrice;
            var deviceTax;
            var deviceLable;
            var lineItemData;
            var accessoryLineItems = [];
            var items = wlsUtils.organizeLineItems(Object.values(losg.lineItems), _this.isMixAndMatch, losg);
            var accessoryPriceView = [];
            var accesoryRtiOosMessage = [];
            var isDeviceItems = [];
            var lineItemDisplay = items.map(function (lineItem, secindex) {
                var _a;
                var keyId = "deviceInfo" + losg.id + "_" + secindex;
                if (lineItem.uiDisplayLineItem) {
                    var subscriber = losg.subscriberName;
                    if (lineItem.itemType.toUpperCase() === 'DEVICE') {
                        lineItemData = lineItem;
                        var imgInfo = wlsUtils.getItemImage(lineItem, losg, _this.isCommonCart);
                        deviceName = _this.displayDeviceLine(lineItem, losg, _this.payload);
                        var modelName = lineItem && lineItem.hardGood && lineItem.hardGood.make && lineItem.hardGood.model
                            ? lineItem.hardGood.make + " " + lineItem.hardGood.model : '';
                        deviceLable = _this.displayEditCapacityModal(lineItem, losg, _this.payload.enableCommitmentViewDate, modelName, wlsUtils.getSubscriberNumber(losg), _this.cartSummaryCMSData.editDeviceLabel);
                        if (imgInfo && imgInfo.imageUrl && _this.externalOrderSourceType !== 'BMWSMART') {
                            imageContainer = (React.createElement("div", { className: styles.deviceImageContainer },
                                React.createElement("img", { src: imgInfo.imageUrl, alt: imgInfo.imgAltText })));
                        }
                        retalPrice = _this.showRetailPrice(lineItem);
                        isDeviceItems.push(true);
                        deviceTax = (_a = lineItem.price) === null || _a === void 0 ? void 0 : _a.tax;
                    }
                    var isAccessoryLineItem = lineItem.itemType.toUpperCase() === 'ACCESSORY';
                    if (isAccessoryLineItem) {
                        var accessoryElement = (React.createElement("div", { key: keyId }, _this.showlineItemContent(lineItem, losg, lineDisplayHeaderText)));
                        var errorMessage = (React.createElement("div", { key: keyId }, wirelessRTI.displayRtiOosAccessoryMessage(lineItem, losg, _this.editLineForPscCustomers, _this.changeAccessoryQuantity, editUrl)));
                        accesoryRtiOosMessage.push(errorMessage);
                        accessoryPriceView.push(accessoryElement);
                        accessoryLineItems.push(lineItem);
                    }
                    return (React.createElement("div", { key: keyId },
                        lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE' &&
                            _this.isMixAndMatch &&
                            _this.showPlanInfoAtLine(lineItem, losg.mnmPlanItems, index, subscriber, _this.payload.enableSignatureEnhancedExperience),
                        lineItem.itemType.toUpperCase() !== 'SHAREDDATAFEATURE' &&
                            lineItem.itemType.toUpperCase() !== 'SHAREDDATAGROUP' &&
                            lineItem.itemType.toUpperCase() !== 'VOICEPLAN' &&
                            lineItem.itemType.toUpperCase() !== 'ACCESSORY' &&
                            Utils.showEarlyUpgradeLineItem(lineItem.itemType, _this.earlyUpgradeAmount) && (React.createElement(React.Fragment, null,
                            _this.showlineItemContent(lineItem, losg, lineDisplayHeaderText),
                            lineItem.itemType.toUpperCase() === 'DEVICE' && (React.createElement("div", { className: styles.flexView }, retalPrice)),
                            _this.showInstallmentMessage(lineItem, losg))),
                        _this.showWaivedText(lineItem),
                        _this.showPromotions(lineItem, isAccessoryLineItem)));
                }
                else {
                    return React.createElement(React.Fragment, { key: keyId });
                }
            });
            var rtiOosDeviceMessage = losg && items &&
                wirelessRTI.displayRtiOosDeviceMessage(losg, _this.filteredLosgsData.length, _this.editLineForPscCustomers, _this.removeLineForPscCustomers, deviceLable, _this.showEditOptions, _this.payload, editUrl);
            var accessoryImageContainer = [];
            var accessoryDisplay = _this.getAccessoryFragments(items, losg, lineDisplayHeaderText);
            accessoryImageContainer = _this.getAccessoryImageContainers(items, accessoryImageContainer);
            return (React.createElement(React.Fragment, { key: "losgInfo" + index }, _this.showCartView(lineItemDisplay, losg, accesoryRtiOosMessage, rtiOosDeviceMessage, imageContainer, lineDisplayName, deviceName, index, retalPrice, deviceTax, accessoryDisplay, accessoryImageContainer, accessoryPriceView, isDeviceItems, lineItemData, accessoryLineItems)));
        })));
    };
    ExpressCart.prototype.displayPlanDetails = function () {
        var _this = this;
        var pricingType = PriceContainerProps_1.PricingType.XSMALL;
        var isPlanHeadingDisplayed = false;
        var isExpressView = this.isExpressUp();
        this.activationLineItemContent = [];
        return (React.createElement(React.Fragment, null,
            this.filteredLosgsData.map(function (losg, index) {
                if ((losg.losgType.toUpperCase() === 'CHANGE' && !losg.displayLine) ||
                    _this.displayPlanDetailsinModal(_this.payload)) {
                    return '';
                }
                if (Object.values(losg.lineItems).filter(function (item) {
                    var _a;
                    return ((_a = item.itemType) === null || _a === void 0 ? void 0 : _a.toUpperCase().search('SHAREDDATAGROUP|SHAREDDATAFEATURE|VOICEPLAN')) > -1 &&
                        item.uiDisplayLineItem;
                }).length < 1) {
                    return '';
                }
                return (React.createElement("div", { key: "linePlan" + index },
                    React.createElement("div", null,
                        React.createElement(React.Fragment, null,
                            !isPlanHeadingDisplayed && (React.createElement("h2", { className: isExpressView ? styles.expupLineHeader : styles.line },
                                _this.cartSummaryCMSData.planLineHeading,
                                (isPlanHeadingDisplayed = true))),
                            wlsUtils.organizeLineItems(Object.values(losg.lineItems), _this.isMixAndMatch)
                                .map(function (lineItem, secindex) {
                                var _a, _b, _c;
                                var lineItemPriceData = wlsUtils.getLineItemPriceData(lineItem, _this.isMixAndMatch, true, _this.isCrpUpgrade);
                                if (isExpressView) {
                                    lineItemPriceData.lineItemPrice.billingNote = '';
                                }
                                if (losg.displayLine &&
                                    lineItem.uiDisplayLineItem &&
                                    (lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP' ||
                                        lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE' ||
                                        lineItem.itemType.toUpperCase() === 'VOICEPLAN')) {
                                    lineItemPriceData.lineItemPrice.price =
                                        _this.isAALFlow || _this.isMixedCart
                                            ? parseFloat("" + lineItemPriceData.lineItemPrice.price)
                                            : _this.sdpData.price + parseFloat("" + lineItemPriceData.lineItemPrice.price);
                                }
                                {
                                    _this.getActivationLineItemContent(lineItem, index);
                                }
                                return (React.createElement("div", { key: "linePlanInfo" + secindex }, losg.displayLine && lineItem.uiDisplayLineItem &&
                                    (lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP' ||
                                        lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE' ||
                                        lineItem.itemType.toUpperCase() === 'VOICEPLAN') && (React.createElement("div", null,
                                    (lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP' ||
                                        lineItem.itemType.toUpperCase() === 'VOICEPLAN') && (React.createElement("div", { className: isExpressView
                                            ? [styles.lineItems, styles.expupLineitemContainer].join(' ')
                                            : styles.lineItems },
                                        React.createElement(ui_components_1.Label, { data: {
                                                isDecodingRequired: false,
                                                text: lineItem.displayName,
                                            }, options: { className: styles.itemName } }),
                                        lineItem.price && lineItemPriceData &&
                                            lineItemPriceData.lineItemPrice &&
                                            lineItemPriceData.lineItemPrice.price > 0 && (React.createElement(ui_components_1.PriceContainer, { testId: utils_1.default('WRLS', "lineItem_" + secindex), data: lineItemPriceData.lineItemPrice, options: {
                                                className: styles.lineItem,
                                                decimalPoints: 2,
                                                type: pricingType,
                                            } })))),
                                    lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP' &&
                                        !(_this.isAALFlow || _this.isMixedCart) && (React.createElement("div", { className: styles.sdpDisclaimer },
                                        _this.sdpData.count === 1 &&
                                            _this.cartSummaryCMSData.deviceAccessCharge1.replace('{0}', (_a = _this.sdpData.price.toFixed(2)) === null || _a === void 0 ? void 0 : _a.toString()),
                                        _this.sdpData.count > 1 && _this.cartSummaryCMSData.deviceAccessCharge2
                                            .replace('{0}', (_b = _this.sdpData.price.toFixed(2)) === null || _b === void 0 ? void 0 : _b.toString())
                                            .replace('{1}', (_c = _this.sdpData.count) === null || _c === void 0 ? void 0 : _c.toString()))),
                                    losg.displayLine &&
                                        lineItem.promotionReferences &&
                                        ((!(_this.isAALFlow || _this.isMixedCart) &&
                                            lineItem.itemType.toUpperCase() === 'SHAREDDATAFEATURE') ||
                                            lineItem.itemType.toUpperCase() === 'SHAREDDATAGROUP') &&
                                        _this.cartData.promotions &&
                                        _this.cartData.promotions.length > 0 && (React.createElement("div", { className: styles.promoContainer }, _this.checkDuplicatePromo(lineItem)))))));
                            })))));
            }),
            this.activationLineItemContent.length > 0 && React.createElement("div", null,
                this.activationLineItemContent,
                " ")));
    };
    ExpressCart.prototype.renderUpgradeCta = function () {
        var _a, _b;
        var upgradeAnotherDevice = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.wirelessCart) === null || _b === void 0 ? void 0 : _b.upgradeAnotherDeviceEligible;
        if (upgradeAnotherDevice === undefined || upgradeAnotherDevice === null) {
            return (React.createElement(React.Fragment, null));
        }
        return (React.createElement(React.Fragment, null,
            !upgradeAnotherDevice &&
                React.createElement(components_1.Alert, { className: styles.upgradeCtaAlertStyle, closeable: false, onWhite: true, style: { textAlign: 'center !important' }, testId: utils_1.default('Cart', 'CartContentChange', '_msg'), type: "info" }, this.cartSummaryCMSData.upgradeLsInfoMsg),
            React.createElement("div", { className: !upgradeAnotherDevice ? styles.upgradeCtaDivDisabled : styles.upgradeCtaDivEnabled },
                React.createElement(Button_1.default, { events: { onClick: this.upgradeCtaEvent }, data: { text: this.cartSummaryCMSData.upgradeLsButtonLabel, disabled: !upgradeAnotherDevice }, options: {
                        accessibility: 'Live a little', className: !upgradeAnotherDevice ? styles
                            .buttonBgDisabled : styles.buttonBgTransparent, type: ButtonProps_1.ButtonType.GHOST,
                    } }))));
    };
    ExpressCart.prototype.upgradeCtaEvent = function () {
        var _a, _b, _c, _d, _e;
        var cartLineSelection = ((_d = (_c = (_b = (_a = this.payload) === null || _a === void 0 ? void 0 : _a.metadata) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.wirelessMetadata) === null || _d === void 0 ? void 0 : _d.upgradeLineSelectionUrl) || ReportingService_1.PageUrls.CART_LINE_SELECTION;
        (_e = this.reportingService) === null || _e === void 0 ? void 0 : _e.fireLinkClickWithOutPageLoad('Upgrade a different line', cartLineSelection);
        window.location.href = cartLineSelection;
    };
    return ExpressCart;
}(WirelessCartHelper_1.default));
exports.default = ExpressCart;
//# sourceMappingURL=ExpressCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/ExpressCart.js
// module id = 2348
// module chunks = 8